import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/en-AU';
import 'intl/locale-data/jsonp/en-GB';
import 'intl/locale-data/jsonp/en-US';

import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/includes';
import 'core-js/features/map';
import 'core-js/features/object/assign';
import 'core-js/features/object/keys';
import 'core-js/features/promise';
import 'core-js/features/set';
import 'core-js/features/string/ends-with';
import 'core-js/features/string/includes';

// Must come after promise polyfill
// Must import unfetch/polyfill/index rather than unfetch/polyfill otherwise
// it includes arrow functions
import 'unfetch/polyfill/index';

// Fixes IE10 regular expression error
if (typeof (Intl as any).__disableRegExpRestore === 'function') {
  (Intl as any).__disableRegExpRestore();
}
